import { render, staticRenderFns } from "./store.vue?vue&type=template&id=b36398fc&scoped=true"
import script from "./store.vue?vue&type=script&lang=js"
export * from "./store.vue?vue&type=script&lang=js"
import style0 from "./store.vue?vue&type=style&index=0&id=b36398fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36398fc",
  null
  
)

export default component.exports